import router from './router'
import store from './store'
import storage from 'store'
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
import notification from 'ant-design-vue/es/notification'
import { setDocumentTitle, domTitle } from '@/utils/domUtil'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { i18nRender } from '@/locales'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const allowList = ['login', 'register', '/callback', '/auth-redirect', '/bind'] // no redirect allowList
const loginRoutePath = '/user/login'
const defaultRoutePath = '/index'

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`))
  /* has token */
  if (storage.get(ACCESS_TOKEN)) {
    if (to.path === loginRoutePath || to.path === '/') {
      next({ path: defaultRoutePath })
      NProgress.done()
    } else {
      // check login user.roles is null
      if (store.getters.roles.length === 0) {
        // request login userInfo
        store
          .dispatch('GetInfo')
          .then(res => {
            // const roles = res.result && res.result.role
            const roles = res.roles
            // generate dynamic router
            store.dispatch('GenerateRoutes', { roles }).then((accessRoutes) => {
              router.addRoutes(store.getters.routers)
              // router.addRoutes(accessRoutes)
              // 请求带有 redirect 重定向时，登录自动重定向到该地址
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
            })
            /**
             * 提前获取省市区数据
             */
            store.dispatch('getCity')
          })
          .catch((error) => {
            console.error('获取用户信息失败:', error)
            // 检查错误信息，如果是401等认证错误，说明token已过期，需要退出登录
            // 如果是网络错误等其他错误，可以尝试重试，不立即退出登录
            const errorMessage = error?.message || ''
            const isAuthError = errorMessage.includes('401') || 
                               errorMessage.includes('U0231') || 
                               errorMessage.includes('U0230') || 
                               errorMessage.includes('U0322') ||
                               errorMessage.includes('登录状态已过期') ||
                               errorMessage.includes('获取用户信息失败')
            
            if (isAuthError) {
              // 认证错误，需要退出登录
              notification.error({
                message: '错误',
                description: '登录状态已过期，请重新登录',
              })
              store.dispatch('Logout').then(() => {
                location.href = '/index'
              })
            } else {
              // 其他错误（如网络错误），提示重试，不退出登录
              notification.error({
                message: '错误',
                description: '请求用户信息失败，请刷新页面重试',
              })
              // 不退出登录，让用户手动刷新
              next({ path: loginRoutePath })
              NProgress.done()
            }
          })
      } else {
        // if (to.path === '/index') {
        //   // location.href = '/index'
        //   let num = store.getters.index ? store.getters.index : 1

        //   store.commit('SET_INDEX', num++)
        //   next()
        // } else {
        //   next()
        // }
        next()
      }
    }
  } else {
    if (allowList.includes(to.name)) {
      // 在免登录名单，直接进入
      next()
    } else {
      next({ path: loginRoutePath, query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
